// extracted by mini-css-extract-plugin
export default {"formBlock":"FormBlock_formBlock__21fII","title":"FormBlock_title__agbRB","control":"FormBlock_control__bL8GS"};